module.exports = __webpack_public_path__ + "static/img/pingxing2.5c91dcc7.png";